'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../../_commonjsHelpers-6ecf82ef.js');
var objectWithoutProperties = require('../../objectWithoutProperties-c6d3675c.js');
var React = require('react');
var index = require('../../index-7124f64c.js');
var taggedTemplateLiteral = require('../../taggedTemplateLiteral-f923b98d.js');
require('styled-components');
var xstyledStyledComponents_es = require('../../xstyled-styled-components.es-6e2bde7d.js');
require('../../extends-5ede7877.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function _templateObject() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n  display: grid;\n  width: 100%;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var gridTemplateColumns = xstyledStyledComponents_es.style({
  prop: 'gridTemplateColumns'
});
var gridTemplateRows = xstyledStyledComponents_es.style({
  prop: 'gridTemplateRows'
});
var gridTemplateAreas = xstyledStyledComponents_es.style({
  prop: 'gridTemplateAreas'
});
var columnGap = xstyledStyledComponents_es.style({
  prop: 'columnGap',
  themeGet: xstyledStyledComponents_es.getSpace
});
var rowGap = xstyledStyledComponents_es.style({
  prop: 'rowGap',
  themeGet: xstyledStyledComponents_es.getSpace
});
var justifyItems = xstyledStyledComponents_es.style({
  prop: 'justifyItems'
});
var alignItems = xstyledStyledComponents_es.style({
  prop: 'alignItems'
});
var placeItems = xstyledStyledComponents_es.style({
  prop: 'placeItems'
});
var alignContent = xstyledStyledComponents_es.style({
  prop: 'alignContent'
});
var justifyContent = xstyledStyledComponents_es.style({
  prop: 'justifyContent'
});
var placeContent = xstyledStyledComponents_es.style({
  prop: 'placeContent'
});
var paddingBottom = xstyledStyledComponents_es.style({
  prop: 'paddingBottom',
  themeGet: xstyledStyledComponents_es.getSpace
});
var paddingLeft = xstyledStyledComponents_es.style({
  prop: 'paddingLeft',
  themeGet: xstyledStyledComponents_es.getSpace
});
var paddingRight = xstyledStyledComponents_es.style({
  prop: 'paddingRight',
  themeGet: xstyledStyledComponents_es.getSpace
});
var paddingTop = xstyledStyledComponents_es.style({
  prop: 'paddingTop',
  themeGet: xstyledStyledComponents_es.getSpace
});
var styleProps = xstyledStyledComponents_es.compose(gridTemplateColumns, gridTemplateRows, gridTemplateAreas, columnGap, rowGap, justifyItems, alignItems, placeItems, justifyContent, alignContent, placeContent, paddingBottom, paddingLeft, paddingRight, paddingTop);
var SystemGrid = xstyledStyledComponents_es.createSystemComponent(React__default['default'], 'div', styleProps);
var GridWrapper = xstyledStyledComponents_es.styled(SystemGrid)(_templateObject(), styleProps);
GridWrapper.displayName = 'GridWrapper';

function _templateObject$1() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var gridColumnStart = xstyledStyledComponents_es.style({
  prop: 'gridColumnStart'
});
var gridColumnEnd = xstyledStyledComponents_es.style({
  prop: 'gridColumnEnd'
});
var gridRowStart = xstyledStyledComponents_es.style({
  prop: 'gridRowStart'
});
var gridRowEnd = xstyledStyledComponents_es.style({
  prop: 'gridRowEnd'
});
var gridColumn = xstyledStyledComponents_es.style({
  prop: 'gridColumn'
});
var gridRow = xstyledStyledComponents_es.style({
  prop: 'gridRow'
});
var gridArea = xstyledStyledComponents_es.style({
  prop: 'gridArea'
});
var justifySelf = xstyledStyledComponents_es.style({
  prop: 'justifySelf'
});
var alignSelf = xstyledStyledComponents_es.style({
  prop: 'alignSelf'
});
var styleProps$1 = xstyledStyledComponents_es.compose(gridColumnStart, gridColumnEnd, gridRowStart, gridRowEnd, gridColumn, gridRow, gridArea, justifySelf, alignSelf);
var SystemGridChild = xstyledStyledComponents_es.createSystemComponent(React__default['default'], 'div', styleProps$1);
var GridChildWrapper = xstyledStyledComponents_es.styled(SystemGridChild)(_templateObject$1(), styleProps$1);
GridChildWrapper.displayName = 'GridChildWrapper';

function Grid(_ref) {
  var children = _ref.children,
      props = objectWithoutProperties.objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React__default['default'].createElement(GridWrapper, props, children);
}
function GridChild(_ref2) {
  var children = _ref2.children,
      props = objectWithoutProperties.objectWithoutProperties(_ref2, ["children"]);

  return /*#__PURE__*/React__default['default'].createElement(GridChildWrapper, props, children);
}
Grid.defaultProps = {
  children: null,
  gridTemplateColumns: {
    xs: 'repeat(4, minmax(0, 1fr))',
    md: 'repeat(6, minmax(0, 1fr))',
    lg: 'repeat(12, minmax(0, 1fr))'
  },
  gridTemplateRows: null,
  gridTemplateAreas: null,
  columnGap: {
    xs: '4x',
    md: '8x'
  },
  rowGap: null,
  justifyItems: null,
  alignItems: null,
  placeItems: null,
  justifyContent: null,
  alignContent: null,
  placeContent: null,
  paddingBottom: null,
  paddingLeft: {
    xs: '6x',
    md: '12x',
    lg: 56
  },
  paddingRight: {
    xs: '6x',
    md: '12x',
    lg: 56
  },
  paddingTop: null
};
GridChild.defaultProps = {
  children: null,
  gridColumnStart: null,
  gridColumnEnd: null,
  gridRowStart: null,
  gridRowEnd: null,
  gridColumn: null,
  gridRow: null,
  gridArea: null,
  justifySelf: null,
  alignSelf: null
};
Grid.propTypes = {
  alignContent: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.object]),
  alignItems: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.object]),
  children: index.propTypes.oneOfType([index.propTypes.node, index.propTypes.func]),
  columnGap: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  gridTemplateAreas: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.object]),
  gridTemplateColumns: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.object]),
  gridTemplateRows: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.object]),
  justifyContent: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.object]),
  justifyItems: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.object]),
  paddingBottom: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  paddingLeft: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  paddingRight: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  paddingTop: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  placeContent: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.object]),
  placeItems: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.object]),
  rowGap: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object])
};
GridChild.propTypes = {
  alignSelf: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.object]),
  children: index.propTypes.oneOfType([index.propTypes.node, index.propTypes.func]),
  gridArea: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.object]),
  gridColumn: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.object]),
  gridColumnEnd: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.object]),
  gridColumnStart: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.object]),
  gridRow: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.object]),
  gridRowEnd: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.object]),
  gridRowStart: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.object]),
  justifySelf: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.object])
};
Grid.Child = GridChild;
Grid.Child.displayName = 'Grid.Child';

exports.Grid = Grid;
exports.GridChild = GridChild;
exports.default = Grid;
//# sourceMappingURL=Grid.js.map
